// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1uI0b","info":"UpdateTermsInfo_info__1Pdm_"};